export const iconFontAwesomeMapsDrawPolygon = (
	<i className="fa-solid fa-draw-polygon"></i>
);
